import { initializeApp } from "firebase/app";
import { type Auth, getAuth } from "firebase/auth";
import { type Firestore, getFirestore } from "firebase/firestore";
import { type Functions, getFunctions } from "firebase/functions";
import { connectToEmulators } from "./emulator-connection";

// Firebase configuration
const firebaseConfig = {
    apiKey: import.meta.env.VITE_DATABASE_API_KEY,
    appId: import.meta.env.VITE_DATABASE_APP_ID,
    authDomain: import.meta.env.VITE_DATABASE_AUTH_DOMAIN,
    messagingSenderId: import.meta.env.VITE_DATABASE_MESSAGING_SENDER_ID,
    projectId: import.meta.env.VITE_DATABASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_DATABASE_STORAGE_BUCKET,
};

// Initialize Firebase app (only if not already initialized)
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth (web persistence)
const authService = getAuth(app);

// Get Firebase services
const db = getFirestore(app);
const functionsService = getFunctions(app, "europe-west2");

// Connect to emulators in development
connectToEmulators(authService, db, functionsService);

export { authService, db, functionsService };
export type { Auth, Firestore, Functions };
